<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    item-text="nome"
    label="Usuário"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @change="onChange"
    v-bind="$attrs"
  >
    <template v-slot:item="item">
      <slot name="item" v-bind:item="item">
        <v-list-item-content>
          <v-list-item-title>
            {{item.item.nome}}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ item.item.email }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </slot>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import UserService from '@/api/user-service';

const DEFAULT_LIMIT = 30;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
  },
  methods: {
    searchUsers(val) {
      if (!val) {
        return;
      }

      if (this.localValue && this.localValue.nome === val) {
        return;
      }

      const term = val.toLowerCase();

      this.loading = true;
      UserService.getAllUsers({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: `nome like "%${term}%" or email like "%${term}%" order by nome`,
      })
        .then((response) => {
          this.items = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onChange(event) {
      this.$emit('change', event);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchUsers, 1000);
    if (this.value) {
      this.items = [this.value];
    }
  },
};
</script>
